import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UnlinkCourseFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteUnlinkCourseFromEntity
  implements UnlinkCourseFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UnlinkCourseFromEntityUseCaseInterface.Params,
  ): Promise<UnlinkCourseFromEntityUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
